var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#EC7C40;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464,32H48C21.492,32,0,53.493,0,80v352c0,26.508,21.492,48,48,48h416c26.508,0,48-21.492,48-48V80 C512,53.493,490.508,32,464,32z M444.664,67c10.492,0,19,8.508,19,19c0,10.493-8.508,19-19,19s-19-8.507-19-19 C425.664,75.508,434.172,67,444.664,67z M374.164,67c10.492,0,19,8.508,19,19c0,10.493-8.508,19-19,19s-19-8.507-19-19 C355.164,75.508,363.672,67,374.164,67z M303.664,67c10.492,0,19,8.508,19,19c0,10.493-8.508,19-19,19s-19-8.507-19-19 C284.664,75.508,293.172,67,303.664,67z M472,432c0,4.406-3.586,8-8,8H48c-4.414,0-8-3.594-8-8V136h432V432z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 208,
    className: "st0",
    width: 288,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 272,
    className: "st0",
    width: 288,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 336,
    className: "st0",
    width: 152,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconOrange);
export default __webpack_public_path__ + "static/media/modal_icon_orange.3d937f715ebdc99a81411b3e2dcc43da.svg";
export { ForwardRef as ReactComponent };